import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../global/authUtils';

/**
 * ProtectedRoute component to handle authentication
 * Redirects to login if user is not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuth = isAuthenticated();

  useEffect(() => {
    // Check token on mount and redirect if invalid
    if (!isAuth) {
      console.log('User not authenticated, redirecting to login');
    }
  }, [isAuth]);

  if (!isAuth) {
    // Redirect to login page but save the location they were trying to access
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
